import type { FaireProductEntity } from "../../entity_types/product";

export const p_fektd9jcp3: FaireProductEntity = {
  token: "p_fektd9jcp3",
  type: "product",
  name: "pH Laboratories - Pure Straight (Salon Kit)",
  brandToken: "b_yvmjqjfezr",
  brandName: "SAYN PRO",
  imageUrl:
    "https://cdn.faire.com/fastly/dd683ffe57534ec579058357acea9ea27ba5ed132f86a23a435771ee4e4d56c5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1386b8039d5fa82ca29bf0b1f1a188ea0cdd588b27e78b68ecc84dffa0a40ecb.png",
    "https://cdn.faire.com/fastly/f535cff7afc4a88c0ba7a8e18f24a7d51c5019c8825486691587586adf8cd9df.png",
    "https://cdn.faire.com/fastly/1cc93ce6e5a5fb03ae2acf5b80345efe6382080182be5a6166581d37d4c72de6.png",
    "https://cdn.faire.com/fastly/843980d306386e2157f178d096054a090be68abb6e1a2693f132f91ea61105aa.jpeg",
    "https://cdn.faire.com/fastly/a451a3faae9972532d2268cb0ff7d3a85677b27ae9303837bc0daffb0108ff11.jpeg",
  ],
  priceDollars: 375,
  description:
    "The pure straight professional straightening treatment, with soy protein and macadamia oil is the ideal solution for those who want to transform their hair from frizzy, curly, wavy and rebellious to straight and silky, with a long-lasting straight hair set. Restores and softens the hair fiber. It gives body, hydration, softness and vitality to dry and damaged hair, to make it visibly brighter, more resistant and bouncier. After the treatment, the hair will finally be tamed, smooth and silky.\n\nThis Kit includes:\n\n * 1 Pure straight Pre Treatment Shampoo (33.8 oz) \n * 1 Pure Straight Active Creme Treatment (16.9 oz) \n * 1 Pure Straight Post Treatment Mask (33.8 oz) ",
  tags: [],
  msrpDollars: 750,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:41.661Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
